module.exports = __webpack_public_path__ + "img/DarallPro_logo_invert_screen_transparent.373c9f8f.svg";